import React from 'react';

const ENERGY_LEVELS = [
   { value: 1, description: 'As bad as it gets' },
   { value: 2, description: 'Could be better' },
   { value: 3, description: 'OK' },
   { value: 4, description: 'No real worries' },
   { value: 5, description: 'As good as it gets' },
];

const EnergySelector = ({ value, onChange, disabled }) => {
   const handleClick = (level) => {
      if (!disabled) {
         onChange(level);
      }
   };

   return (
      <div className="form-section energy-section">
         <div className="section-label">
            <span className="section-dot" style={{ background: '#ffccbc' }} />
            <span>Energy</span>
         </div>
         <div className="energy-selector-vertical">
            {ENERGY_LEVELS.map(level => (
               <div
                  key={level.value}
                  className={`energy-circle ${value === level.value ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                  onClick={() => handleClick(level.value)}
               >
                  {level.value}
               </div>
            ))}
         </div>
         <div className="energy-legend-vertical">
            <span>Numbered 1-5 with</span>
            <span>1. As bad as it gets</span>
            <span>2. Could be better</span>
            <span>3. Ok</span>
            <span>4. No real worries</span>
            <span>5. As good as it gets</span>
         </div>
      </div>
   );
};

export default EnergySelector;
